import {Component} from '@angular/core';
import {NavController,ToastController,AlertController} from 'ionic-angular';
import {LoginPage} from '../login/login';
import {Api} from '../../providers/api';
import { AppConfig } from '../../providers/config';
import { CodesDTO, SignUpDTO } from '../../providers/data';
import {FormBuilder, FormGroup, FormControl, Validators, AbstractControl} from '@angular/forms';
import {GVLogger} from "../../services/gv-logger";



/*
 Generated class for the LoginPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})



export class RegisterPage {

	signupform: FormGroup;
	userData = { "username": "", "password": "", "email": "", "name": "" };


	equalto(field_name){
        return (control: AbstractControl): { [key: string]: any } => {
            let input = control.value;
            let isValid = control.root.value[field_name] == input;
            if (!isValid)
                return {'equalTo': {isValid}};
            else
                return null;
        };
	}

	isSelected(){
        return (control: AbstractControl): { [key: string]: any } => {
            let input = control.value;
            let isValid = this.countries[0].description || this.countries[1].description == input;
            if (!isValid)
                return {'equal': {isValid}};
            else
                return null;
        };
	}

	// isSelected(){
	// 	return (control: AbstractControl): { [key: string]: any } => {
    //         let isValid = false;

	// 		this.countries.map(country=>{
	// 			if(control.value === this.countries.description)
	// 				isValid == true;
	// 		});

    //         if (!isValid)
    //             return {'equal': {isValid}};
    //         else
    //             return null;
    //     };
	// }

  // AppConfig = AppConfig;
	userUnique = false;
	countries:any=[{code:"+92",description:"Pakistan"},{code:"+1",description:"Canada"},{code:"",description:"Others"}]
	emailPattern:any=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	// phonePattern = /[0-9\+\-\ ]/;
	phonePattern = /^[\+[0-9]{0,3}]?[-\s\.]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  countryCode:CodesDTO

	signUpForm = {
		companyName: "",
		userName: "",
		firstName: "",
		lastName: "",
		country: this.countries[0].description,
		phoneCode: "+92",
		phoneNo: "",
		custype: "",
		email: "",
		password: "",
		confirmPassword:""

	}
	setProfileBadge:boolean;
	constructor(private api: Api,
              public toastCtrl:ToastController,
              public nav: NavController,
              private alertController:AlertController,
              public formBuilder: FormBuilder,
              private gVLogger: GVLogger)
	{
		let phonePattern = /^[\+[0-9]{0,3}]?[-\s\.]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
	let EMAILPATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // this.signupform = this.formBuilder.group({
	// 	'username': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
	// 	'email': ['', Validators.compose([Validators.required, Validators.pattern(EMAILPATTERN)])],
	// 	'password': ['', Validators.required, Validators.minLength(3)],
	// 	'confirmPassword': ['', Validators.required, Validators.minLength(3), this.equalto('password')],
	// 	'usertype': ['', Validators.required],
	// 	'country': ['', Validators.required],
	// 	'firstName': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
	// 	'lastName': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
	// 	'companyName': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
	// 	'telCountryCode': ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(3)])],
	// 	// 'telSimCode': ['', Validators.compose([Validators.required, Validators.minLength(3)]), Validators.maxLength(3)],
	// 	'phone': ['', Validators.compose([Validators.required, Validators.minLength(10)])],
	// });


	this.signupform = new FormGroup({
		username: new FormControl('', [Validators.required, Validators.minLength(3)]),
	  //   password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(12)]),
		firstName: new FormControl('', [Validators.required, Validators.minLength(3)]),
		lastName: new FormControl('', [Validators.required, Validators.minLength(3)]),
		companyName: new FormControl('', [Validators.required, Validators.minLength(3)]),
		email: new FormControl('', [Validators.required, Validators.pattern(EMAILPATTERN)]),
		password: new FormControl('', [Validators.required, Validators.minLength(3)]),
		confirmPassword: new FormControl('', [Validators.required, Validators.minLength(3), this.equalto('password')]),
		phoneNo: new FormControl('', [Validators.required, Validators.pattern(phonePattern)]),
		country: new FormControl('', [Validators.required]),
	    custype: new FormControl('', [Validators.required]),
	  });

	//   this.signupform = new FormGroup({
	// 	username: new FormControl('', []),
	//   //   password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(12)]),
	// 	firstName: new FormControl('', []),
	// 	lastName: new FormControl('', []),
	// 	companyName: new FormControl('', []),
	// 	email: new FormControl('', []),
	// 	password: new FormControl('', []),
	// 	confirmPassword: new FormControl('', []),
	// 	phone: new FormControl('', []),
	// 	country: new FormControl('', []),
	//     custype: new FormControl('', []),
	//   });

		this.countryCode = {
			"id": 1,
			"abbrivation": "PKR",
			"description": "Pakistan",
			"code": "+92",
			"parentId": 0,
			"status": ""
			}


	}

	checkOptions(val){

		if(val === undefined || val === null){
			return null;
		}
		return true;
	}

	onRegisterFormSubmit(values:any):void{


		let SignUP = new SignUpDTO(
			"",
			this.countryCode,
			this.signUpForm.companyName,
			this.countryCode.description,
			values.custype,
			this.signUpForm.email,
			this.signUpForm.firstName,
			this.signUpForm.lastName,
			"",
			this.signUpForm.password,
			this.signUpForm.phoneCode + values.phoneNo,
			"",
			"",
			this.signUpForm.userName,
			);

		let body:any = {
			username : this.signUpForm.userName
		};

		this.api.userAvailabilityRA('api/v1/users/checkAvailability', body)
			.subscribe(resp => {
				let jsonObj = resp.json();
				this.gVLogger.log(body)


				if (jsonObj.status == 200) {
					this.gVLogger.log("username available")

						this.api.postRA("/api/v1/users/signup", SignUP).subscribe(
							result=>{

								let respObj=result.json();
								if (respObj.status === 200) {
									this.setProfileBadge=true;
									this.api.setIfFirstLogin(this.setProfileBadge)
									// this.api.toastMsg(respObj.message, "")
                  let toast = this.toastCtrl.create({
                    message: respObj.message,
                    duration: 3000
                    });
                    toast.present();
									// this.signUpForm = {
									// 	companyName: "",
									// 	userName: "",
									// 	firstName: "",
									// 	lastName: "",
									// 	country:  this.countries[0].description,
									// 	phoneCode: "+92",
									// 	phone: "",
									// 	userType: "",
									// 	email: "",
									// 	password: "",
									// 	confirmPassword:""
									// }
									// this.api.gotoLogOut();
									// this.hideLoader();
									this.nav.setRoot(LoginPage);
								} else if(respObj.status==409) {
									this.gVLogger.log("Email already exist")
                  // this.api.toastMsg(respObj.message,"");
                  let toast = this.toastCtrl.create({
                    message: respObj.message,
                    duration: 3000
                    });
                    toast.present();
									// this.hideLoader();
									this.nav.setRoot(LoginPage);
								}
							})

				}else if(jsonObj.status == 409){
					this.gVLogger.log("user already exist")
          // this.api.toastMsg(jsonObj.message,"");
            let toast = this.toastCtrl.create({
            message: jsonObj.message,
            duration: 3000
            });
            toast.present();
					// this.hideLoader();
					this.nav.setRoot(LoginPage);
				}
				});

	}

	getcountryCode(countryName:String){
		if(countryName=="Pakistan"){
			this.signUpForm.phoneCode="+92";
			this.countryCode = {
				"id": 1,
				"abbrivation": "PKR",
				"description": "Pakistan",
				"code": "+92",
				"parentId": 0,
				"status": ""
				};
		} else if(countryName=="Canada"){
			this.signUpForm.phoneCode="+1";
			this.countryCode= {
				"id": 2,
				"abbrivation": "NA",
				"description": "Canada",
				"code": "+1",
				"parentId": 0,
				"status": ""
				};
		} else if(countryName=="Others"){

			// this.api.toastMsg("Service is not available in your region","");
				this.signUpForm.country="";
		}
}

  // company:string;
  // email:string;
  // userName:string;
  // password:string;

  // constructor(public nav: NavController,
  //   private toastController:ToastController ,
  //   private alertController:AlertController,
  //   private api:Api) {
  //   this.company = "";
  //   this.email = "";
  //   this.userName = "";
  //   this.password = "";
  // }

  // // go to login page
  // login() {
  //   this.nav.setRoot(LoginPage);
  // }

  // // go to home page
  // register() {
  //   if(this.company !="" && this.email != "" && this.userName != "" && this.password != ""){

  //        let body =  {
  //             "id": "0",
  //             "companyName":  this.company,
  //             "userName":  this.userName,
  //             "password":  this.password,
  //             "email":  this.email,
  //             "createdAt":  "",
  //             "updatedAt":  "",
  //             "phone":  "",
  //             "subscriptionPackage":  "",
  //             "noOfEmployees":  "",
  //             "address":  "",
  //             "referal":  ""
  //           };

  //           this.gVLogger.log(JSON.stringify(body));
  //        this.api.postRA("adpCustomer/registration",body).map(res => res.json()).subscribe(result =>{
  //          if(result.status == "200"){
  //            let toast = this.toastController.create({
  //              message: "Successfully registered.",
  //              duration: 3000
  //            });
  //            toast.present();
  //            this.nav.setRoot(LoginPage);
  //          }
  //        });
  //   }else{
  //     this.presentAlert("Can't Proceed","Please fill all fields","ok")
  //   }
  // }

  // presentAlert(title,msg,buttonText) {
  //   let alert = this.alertController.create({
  //     title: title,
  //     subTitle: msg,
  //     buttons: [buttonText]
  //   });
  //   alert.present();
  // }

   login() {
    this.nav.setRoot(LoginPage);
  }

//   activateLoader() {
// 	this.layoutService.updatePreloaderState('active');
// }
// hideLoader() {
// 	this.layoutService.updatePreloaderState('hide');
// }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts